<template>
  <div class="relative">
    <client-only>
      <div v-if="showMap" id="map" style="height: 600px; width: 100%"></div>
    </client-only>
  </div>
</template>

<script>
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import 'mapbox-gl-controls/lib/controls.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
const StaticMode = require('@mapbox/mapbox-gl-draw-static-mode')

export default {
  name: 'MapRenderer',
  props: {
    data: {
      type: Object,
      required: true,
    },
    showMap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      map: null,
      coords: [],
      accessToken:
        'pk.eyJ1IjoiZ3JlYmUxOTkxIiwiYSI6ImNrcjF3MDl0ejI1bm4ycW82dHM1Mzl1cmMifQ.bdG78NAiFuxu2omfuTyouQ',
    }
  },
  mounted() {
    if (this.showMap) {
      this.getUserLocation(false)
    }
  },
  methods: {
    async getUserLocation(satelliteMap = false) {
      await this.$nextTick()
      if (this.data.markers && this.data.markers.length) {
        this.coords = [this.data.markers[0].lng, this.data.markers[0].lat]
        this.createMap(satelliteMap)
        return
      }

      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const crd = pos.coords
          this.coords = [crd.longitude, crd.latitude]
          this.createMap(satelliteMap)
        },
        () => {
          if (this.data.markers && this.data.markers.length) {
            this.coords = [this.data.markers[0].lng, this.data.markers[0].lat]
            this.createMap(satelliteMap)
          }
        },
        options
      )
    },
    createMap() {
      if (!mapboxgl.supported()) {
        this.$errorAlert(
          'Browserul dumneavoastra nu suporta functionalitatile necesare pentru randarea hărții'
        )
        return
      }

      mapboxgl.accessToken = this.accessToken
      this.map = new mapboxgl.Map({
        accessToken:
          'pk.eyJ1IjoiZ3JlYmUxOTkxIiwiYSI6ImNrcjF3MDl0ejI1bm4ycW82dHM1Mzl1cmMifQ.bdG78NAiFuxu2omfuTyouQ',
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11?optimize=true',
        zoom: 11,
        scrollZoom: false,
        center: this.coords,
      })

      this.map.addControl(new mapboxgl.FullscreenControl())
      this.map.addControl(new mapboxgl.NavigationControl())
      this.map.addControl(
        new this.$stylesControl({
          styles: [
            {
              label: 'Satellite',
              styleName: 'Satellite',
              styleUrl: 'mapbox://styles/mapbox/satellite-v9?optimize=true',
            },
            {
              label: 'Outdoors',
              styleName: 'Outdoors',
              styleUrl: 'mapbox://styles/mapbox/outdoors-v11?optimize=true',
            },
          ],
        }),
        'top-left'
      )

      this.map.on('load', () => {
        this.data.markers.forEach((marker) => this.addNewMarker(marker))
        const modes = MapboxDraw.modes
        modes.static = StaticMode
        const draw = new MapboxDraw({
          displayControlsDefault: false,
          modes,
        })
        this.map.addControl(draw, 'top-left')
        draw.add(this.data.draw)
        draw.changeMode('static')
      })
    },
    addNewMarker(marker) {
      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        closeOnClick: false,
      }).setText(marker.text)

      new mapboxgl.Marker({
        draggable: false,
      })
        .setLngLat([marker.lng, marker.lat])
        .addTo(this.map)
        .setPopup(popup)
    },
  },
}
</script>
